// @ts-check
import Axios from "axios";
import { Appsettings } from "../Appsettings";
/**
 *
 * @param {string} phone
 * @param {Object} message
 * @param {string} message.nombre
 * @param {string} message.link
 * @param {string} message.token
 */
export async function shareWhatsapp(phone, message) {
  if (phone === "") {
    alert("número telefónico inválido");
    return;
  }

  // 1. Abrimos la pestaña inmediatamente para que Safari vea la interacción
  const emptyWindow = window.open("", "_blank");

  try {
    let templateReq = await Axios.get(Appsettings.whatsappMessage, {
      headers: { "Cache-Control": "no-cache" },
    });

    let template = templateReq.data;
    const link = window.location.origin + "/externo/" + message.token;
    template = template.replace("[[NOMBRE]]", message.nombre);
    template = template.replace("[[LINK]]", link);

    const url = `https://wa.me/${phone}?text=${template}`;

    // 2. Cambiamos la URL de la pestaña que ya está abierta
    if (emptyWindow) {
      emptyWindow.location.href = url;
    }
  } catch (error) {
    // Si la petición falla, cerramos la pestaña y avisamos
    if (emptyWindow) emptyWindow.close();
    console.error("Error obteniendo el template", error);
  }
}

export default shareWhatsapp;
